import { NgModule } from '@angular/core';

// Angular Material Components
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { TlkSlideToggleComponent } from '@itero/ui-toolkit-angular/slide-toggle';
import { TlkCheckboxComponent } from '@itero/ui-toolkit-angular/checkbox';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MomentDateModule } from '@angular/material-moment-adapter';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatRippleModule } from '@angular/material/core';
@NgModule({
	declarations: [],
	imports: [
		TlkButtonComponent,
		MatToolbarModule,
		MatInputModule,
		TlkSlideToggleComponent,
		TlkCheckboxComponent,
		MatGridListModule,
		MatIconModule,
		MomentDateModule,
		MatMomentDateModule,
		MatMenuModule,
		MatDividerModule,
		ClipboardModule,
		MatSnackBarModule,
		MatTableModule,
		MatTooltipModule,
		MatRippleModule
	],
	exports: [
		TlkButtonComponent,
		MatToolbarModule,
		MatInputModule,
		TlkSlideToggleComponent,
		TlkCheckboxComponent,
		MatGridListModule,
		MatIconModule,
		MatDatepickerModule,
		MatMenuModule,
		MatDividerModule,
		MatExpansionModule,
		ClipboardModule,
		MatSnackBarModule,
		MatTableModule,
		MatTooltipModule,
		MatRippleModule,
		MomentDateModule,
		MatMomentDateModule
	]
})
export class MaterialModule {}
